import { useAppSelector } from './store-hook';
import useTranslation from './translation-hook';
import { campaignSignupCopy } from '../localization/campaignSignupCopy';

export default function useCampaignTranslation(language?: string) {
  const uiLanguage = useAppSelector(s => s.userPrefs.uiLanguage);
  const translate = useTranslation();
  const locale = (language || uiLanguage || 'fr').startsWith('fr') ? 'fr' : 'en';
  return (key: string, fallback?: string) => translate(key, {
    locale, defaultValue: campaignSignupCopy[locale][key] ?? fallback ?? key,
  });
}
